var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"value":_vm.selected_industry,"options":_vm.industries,"searchable":false,"clearable":false,"components":{ OpenIndicator: _vm.OpenIndicator }},on:{"input":_vm.setSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }